// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import AppsFormDateField from './apps_form_date_field';

export default AppsFormDateField;
